import React from "react"
import styled from "styled-components"
import { MARKS, BLOCKS, INLINES } from "@contentful/rich-text-types"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"

import { TYPE, COLORS } from "../../../theme/styles/globals"
import Button from "../atoms/input/button"

const ArticleTextField = ({ json }) => {
    //console.log(json)
    const options = {
        renderNode: {
            [MARKS.BOLD]: (_, children) => <BOLD>{children}</BOLD>,
            [BLOCKS.PARAGRAPH]: (_, children) => <P>{children}</P>,
            [BLOCKS.HEADING_2]: (_, children) => <H2>{children}</H2>,
            [BLOCKS.HEADING_3]: (_, children) => <H3>{children}</H3>,
            [BLOCKS.HEADING_4]: (_, children) => <H4>{children}</H4>,
            [BLOCKS.EMBEDDED_ASSET]: (node, children) => {
                //console.log(json)
                // render the EMBEDDED_ASSET as you need
                //console.log(node)
                //console.log(children)
                if (!node) {
                    return (
                        <Video muted autoPlay playsInline loop>
                            <source src={`query for asset url`} type="video/mp4" />
                        </Video>
                    )
                } else {
                    return (
                        <Image src={`query for asset url`} />
                    )
                }
            },
            [INLINES.HYPERLINK]: ({ data }, children) => (
                <LINK
                  href={data.uri}
                  target='_blank'
                >{children}</LINK>
              )
        }
    }

    return(
        <Container>
            { documentToReactComponents(json, options) }
        </Container>
    )
}

export default ArticleTextField

const Container = styled.div`
    font-family:${TYPE.SERIF_FONT};
`

const BOLD = styled.span`
    font-family:${TYPE.SERIF_BOLD_FONT};
`

const LINK = styled.a`
    font-family:${TYPE.SERIF_FONT};
    text-decoration: underline;
    color:${COLORS.LIGHT_GREY_4};
    &:hover {
        color:${COLORS.DARK_GREY_4};
    }
`

const P = styled.div`
    margin-bottom:30px;
    line-height:24px;
`

const H2 = styled.h2`
    font-family:${TYPE.SERIF_BOLD_FONT};
    font-size:48px;
    line-height:48px;
    margin-bottom:30px;
    font-weight:normal;
`

const H3 = styled.h3`
    font-family:${TYPE.SERIF_BOLD_FONT};
    font-size:36px;
    line-height:42px;
    margin-bottom:30px;
    font-weight:normal;
`

const H4 = styled.h4`
    font-family:${TYPE.SERIF_BOLD_FONT};
    font-size:24px;
    line-height:24px;
    margin-bottom:30px;
    font-weight:normal;
`

const Image = styled.img`
  width:100%;
`

const Video = styled.video`
  width:100%;
`